import dayjs from 'dayjs';
import { ref, toRefs, watch, computed } from 'vue';
import { useScroll } from '@vueuse/core';
import { useI18n } from '@mcex/locale';

const loading = ref(false);
export function useConfirmModal() {
  const { t } = useI18n();
  const setLoading = (value) => {
    loading.value = value;
  };
  /**
   * 获取交易成功展示信息
   * @returns 交易发起成功，将于今天 24:00 前更新交易结果。
   */
  const getTradeContent = () => {
    // 获取今天的日期
    const today = dayjs().format('YYYY-MM-DD');
    return (
      <p>
        {t('mcex.product.tradeSuccessPrefix')}{' '}
        <span style={{ color: 'var(--primary-color)' }}>{today} 24:00 </span>{' '}
        {t('mcex.product.tradeSuccessSuffix')}
      </p>
    );
  };
  return { loading, setLoading, getTradeContent };
}

export function useAgreeTip(tradeNotice) {
  const readMe = computed(() => {
    return true;
  });
  const checked = ref(false);
  /**
   * 协议滚动监听
   * 判断是否阅读到底
   */
  const agreeBox = ref<HTMLElement | null>(null);
  const { isScrolling, arrivedState } = useScroll(agreeBox, {
    offset: {
      bottom: 3,
    },
  });
  /**
   * 是否滚动到过底部
   */
  const isBottom = ref(false);
  const { bottom } = toRefs(arrivedState);
  watch(
    () => bottom.value,
    (val) => {
      if (val) {
        isBottom.value = true;
      }
    },
  );
  /**
   * 校验状态
   * 是否开始校验
   */
  const valid = ref(false);

  /**
   * 提示阅读协议
   * 开始校验
   * 并且没有勾选
   */
  const showAlter = computed(() => {
    return valid.value && !checked.value;
  });

  function hasScrollbar(element: HTMLElement): boolean {
    return element.scrollHeight > element.clientHeight;
  }
  /**
   * 勾选时判断是否滚动到底部，
   * 已滚动到底部过则勾选并关闭校验
   * 滚动到底部则勾选并且关闭开始校验
   * 否则不勾选并开启校验
   */
  const checkChange = (e) => {
    // 判断agreeBox是否可滚动
    const hasScroll = hasScrollbar(agreeBox.value as HTMLElement);
    const currenCheck = e.target.checked;

    if ((currenCheck && isBottom.value) || !hasScroll) {
      checked.value = currenCheck;
      valid.value = false;
      return;
    }
    // 勾选则判断是否有协议并且滚动到底部，未滚动到底部则不勾选并显示提示
    if (currenCheck && !bottom.value && !!tradeNotice.value) {
      checked.value = false;
      valid.value = true;
      return;
    }
    valid.value = false;
  };

  /**
   * 滚动则重置校验状态
   */
  watch(
    () => isScrolling.value,
    (val) => {
      if (val) {
        valid.value = false;
      }
    },
  );

  const checkAgree = () => {
    valid.value = true;
    if (!checked.value) return false;
    valid.value = false;
    return true;
  };

  const init = () => {
    checked.value = false;
    valid.value = false;
    isBottom.value = false;
    agreeBox.value?.scrollTo(0, 0);
  };
  return {
    readMe,
    checked,
    agreeBox,
    checkChange,
    showAlter,
    init,
    checkAgree,
    isBottom,
  };
}
